import axios from 'axios';
import API from './API';
import { PAGE_ROUTES } from './constants';
import { isObjectValidAndNotEmpty, isTextValidAndNotEmpty } from './nullChecks';
import { SessionData } from '../types/LogInTypes';

export const DESTINATION = 'destination';
export const getRedirectionPathWithDestination = (destination: string) => {
    if (isTextValidAndNotEmpty(destination)) {
        return `${PAGE_ROUTES.BASE_ROUTE}?${DESTINATION}=${destination}`;
    }
    return PAGE_ROUTES.BASE_ROUTE;
};

export const getSessionDataIfSessionIsValid = async () => {
    try {
        const sessionResponse = await axios.get(API.SESSION.GET_CURRENT);
        if (isObjectValidAndNotEmpty<SessionData>(sessionResponse.data)) {
            return sessionResponse.data;
        }
        return null;
    } catch (error) {
        return null;
    }
};
